/* Kipnook Fluid v1 — progressive enhancement only: every feature checks support and the page works without it. */
(function(){
  var d=document;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Instant press feedback on touch (enables :active on iOS on pointer-down) */
  d.addEventListener('touchstart',function(){},{passive:true});

  /* Header: show the edge only once content scrolls underneath */
  var header=d.querySelector('.header');
  if(header){
    var ann=d.querySelector('.announcement');
    var setAnn=function(){d.documentElement.style.setProperty('--kp-ann',(ann?ann.offsetHeight:0)+'px');};
    setAnn();window.addEventListener('resize',setAnn,{passive:true});
    var ticking=false;
    var setEdge=function(){header.classList.toggle('is-scrolled',window.scrollY>8);ticking=false;};
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(setEdge);}},{passive:true});
    setEdge();
  }

  /* Images still loading fade in when decoded instead of popping */
  [].forEach.call(d.querySelectorAll('.product-image img,.product-gallery img,.checks-photo img,.cart-row img'),function(img){
    if(img.complete&&img.naturalWidth)return;
    img.classList.add('kp-fade');
    var done=function(){img.classList.add('is-loaded');};
    img.addEventListener('load',done,{once:true});
    img.addEventListener('error',done,{once:true});
  });

  /* Reveal content as it enters the viewport (skipped for reduced motion) */
  if('IntersectionObserver' in window&&!reduce){
    var sel='.trust-item,.section-head,.journey,.product-card,.checks-photo,.checks-copy,.dogcat-panel,.kit,.faq-item,.newsletter-grid>*,.guide-card,.empty-state';
    var fold=window.innerHeight*0.92;
    var targets=[].filter.call(d.querySelectorAll(sel),function(el){return el.getBoundingClientRect().top>fold;});
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
    },{rootMargin:'0px 0px -6% 0px',threshold:0.06});
    targets.forEach(function(el){
      var sibs=el.parentElement?[].filter.call(el.parentElement.children,function(c){return targets.indexOf(c)>-1;}):[];
      var i=Math.max(0,sibs.indexOf(el))%4;
      el.style.setProperty('--kp-d',(i*70)+'ms');
      el.classList.add('kp-reveal');
      io.observe(el);
    });
  }

  /* Mobile gallery position counter */
  var gal=d.querySelector('.product-gallery');
  if(gal){
    var items=function(){return [].filter.call(gal.children,function(c){return c.matches('a,video,.product-image');});};
    if(items().length>1){
      var count=d.createElement('div');
      count.className='kp-gallery-count';
      count.setAttribute('aria-hidden','true');
      gal.after(count);
      var upd=function(){
        var list=items(),left=gal.getBoundingClientRect().left,idx=0,best=Infinity;
        list.forEach(function(el,i){var dist=Math.abs(el.getBoundingClientRect().left-left);if(dist<best){best=dist;idx=i;}});
        count.textContent=(idx+1)+' / '+list.length;
      };
      var raf=0;
      gal.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(upd);},{passive:true});
      upd();
    }
  }

  /* Image viewer grows from the photo that was tapped (and returns to it) */
  d.addEventListener('click',function(e){
    var link=e.target.closest&&e.target.closest('[data-image-zoom]');
    if(!link)return;
    var dlg=d.querySelector('[data-image-dialog]');
    if(!dlg||!dlg.open)return;
    var r=link.getBoundingClientRect(),dr=dlg.getBoundingClientRect();
    dlg.style.transformOrigin=Math.round(r.left+r.width/2-dr.left)+'px '+Math.round(r.top+r.height/2-dr.top)+'px';
  });

  /* Mobile quick-add bar: appears whenever the main button is off screen */
  var form=d.querySelector('.product-copy form[action*="/cart/add"]');
  var addBtn=form&&form.querySelector('button[name="add"]');
  if(form&&addBtn&&'IntersectionObserver' in window){
    var titleEl=d.querySelector('.product-copy h1');
    var priceEl=d.querySelector('[data-product-price]');
    var bar=d.createElement('div');
    bar.className='kp-buybar';
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label','Quick add to bag');
    bar.innerHTML='<div class="kp-buybar__info"><p class="kp-buybar__title"></p><p class="kp-buybar__price"></p></div><button type="button" class="btn btn--brass kp-buybar__btn"></button>';
    bar.querySelector('.kp-buybar__title').textContent=titleEl?titleEl.textContent.trim():'';
    var bPrice=bar.querySelector('.kp-buybar__price'),bBtn=bar.querySelector('button');
    var sync=function(){
      bPrice.textContent=priceEl?priceEl.textContent.trim():'';
      bBtn.textContent=addBtn.textContent.trim();
      bBtn.disabled=addBtn.disabled;
    };
    sync();
    new MutationObserver(sync).observe(addBtn,{attributes:true,childList:true,characterData:true,subtree:true});
    if(priceEl)new MutationObserver(sync).observe(priceEl,{childList:true,characterData:true,subtree:true});
    bBtn.addEventListener('click',function(){
      if(addBtn.disabled)return;
      if(form.requestSubmit){form.requestSubmit(addBtn);}else{addBtn.click();}
    });
    d.body.appendChild(bar);
    d.body.classList.add('kp-has-buybar');
    var mq=matchMedia('(max-width: 960px)');
    var btnSeen=true,footSeen=false;
    var render=function(){
      var show=mq.matches&&!btnSeen&&!footSeen;
      bar.classList.toggle('is-visible',show);
      bar.inert=!show;
      bar.setAttribute('aria-hidden',show?'false':'true');
    };
    new IntersectionObserver(function(es){btnSeen=es[es.length-1].isIntersecting;render();}).observe(addBtn);
    var footer=d.querySelector('.footer');
    if(footer)new IntersectionObserver(function(es){footSeen=es[es.length-1].isIntersecting;render();}).observe(footer);
    if(mq.addEventListener)mq.addEventListener('change',render);
    render();
  }
})();
